// extracted by mini-css-extract-plugin
module.exports = {"container":"bank_container__16SxQ","money":"bank_money__2HUq1","img":"bank_img__3y8wy"};